<!--
 * @Author: 孙照
 * @LastEditTime: 2023-11-24 17:02:09
 * @Description: 单站充电弹框
 * @FilePath: \sheyang\src\module\overview\stationChargeModal\index.vue
-->
<template>
  <div class="station-charge-modal">
    <pub-main-modal
      :visible="visible"
      @change-visible="onChangeVisible"
    >
      <template slot="content">
        <div class="station-charge-content">
          <div class="left">
            <station-info-items :stationInfo="stationInfoData" />
            <user-charging-ans
              :chargingNumber="userBehavior.chargingNumber"
              :chargingPercent="userBehavior.chargingPercent"
              :xAxisData="userBehavior.xAxisData"
            />
            <recent-day-charging-pw
              :userNumber="recentMonthUserData.userNumber"
            />
          </div>
          <div class="center">
            <station-select />
            <bus-lines />
            <current-charging :stationId="currentStationId" />
          </div>
          <div class="right">
            <recent-month-carbon :carbonEmissionsData="carbonEmissionsData"/>
            <recent-month-charge-power :graphGradientData="graphGradientData" />
            <charging-process :processLsit="processLsit"/>
          </div>
        </div>
      </template>
    </pub-main-modal>
  </div>
</template>

<script>
import pubMainModal from '@/components/pubMainModal/index.vue'; // 一级公共弹框
import { STATION_MODAL_CHANGE } from '@/store/const';
import { toDecimal, getTime } from '@/utils';
import {
  getDayAnalyseData,
  getMonthAnalyseData,
  getChargingProcess,
  getChargeStatus,
} from '@/api/stationStatistics/index';
import { mapMutations, mapActions, mapGetters } from 'vuex';
import stationSelect from '@/module/stationSelect/index.vue'; // 场站选择下拉框
import stationInfoItems from './components/infoItems.vue'; // 数据统计组件
import userChargingAns from './components/userChargingAns.vue'; // 用户充电行为分析
import recentDayChargingPw from './components/recentDayChargingPw.vue'; // 24小时功率分布
import recentMonthCarbon from './components/recentMonthCarbon.vue'; // 近一月碳减排趋势
// 近一月充电量与充电次数趋势
import recentMonthChargePower from './components/recentMonthChargePower.vue';
// 充电过程数据
import chargingProcess from './components/chargingProcess.vue';
import busLines from './components/busLines.vue'; // 公交线路组件
import currentCharging from './components/currentCharging.vue'; // 当前充电情况

export default {
  name: 'stationChargeModal',
  components: {
    pubMainModal,
    stationInfoItems,
    userChargingAns,
    recentDayChargingPw,
    stationSelect,
    recentMonthCarbon,
    recentMonthChargePower,
    chargingProcess,
    busLines,
    currentCharging,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      stationInfoData: {}, // 单站数据信息
      carbonEmissionsData: {
        index: [],
        chargingCapacity: [],
        reduceCarbon: [],
      },
      graphGradientData: {
        key: '2',
        index: [],
        chargingCapacity: [],
        chargeTimes: [],
      },
      processLsit: [],
      // 用户充电行为分析数据
      userBehavior: {
        chargingNumber: [],
        chargingPercent: [],
        xAxisData: [],
      },
      // 近一月用户分布趋势
      recentMonthUserData: {
        xAxisData: [],
        userNumber: [],
      },
    };
  },
  computed: {
    ...mapGetters({
      stationId: 'stationId',
      stationList: 'stationList',
      stationInfo: 'charging/stationInfo',
      currentStationId: 'currentStationId',
    }),
  },
  watch: {
    currentStationId(val) {
      console.log('currentStationId', val);
      if (!val) return;
      this.getStationList();
      this.getStationInfo(val);
      this.fetchDayAnalyseData(val);
      this.fetchMonthAnalyseData(val);
      this.fetchChargingProcess(val);
    },
    stationInfo: {
      handler(val) {
        this.stationInfoData = { ...val };
      },
      deep: true,
    },
  },
  methods: {
    ...mapMutations([
      STATION_MODAL_CHANGE,
    ]),
    ...mapActions({
      getStationList: 'getStationList', // 获取电站列表
      getStationInfo: 'charging/getStationInfo', // 获取今日数据
    }),
    // 更改弹框状态
    onChangeVisible(flag) {
      this[STATION_MODAL_CHANGE](flag);
    },
    // 用户充电行为分析
    fetchDayAnalyseData(stubGroupId) {
      getDayAnalyseData({ stubGroupId }).then(((res) => {
        const timeData = [];
        const chargeNum = [];
        const chargeUserAmountRate = [];
        const total = res.data.reduce((a, b) => a + Number(b.chargeNum), 0);
        res.data.map((item) => {
          timeData.push(item.time);
          chargeNum.push(item.chargeNum);
          const percent = total ? (item.chargeNum / total) * 100 : 0;
          chargeUserAmountRate.push(percent);
        });
        this.userBehavior.xAxisData = [...timeData];
        this.userBehavior.chargingNumber = [...chargeNum];
        this.userBehavior.chargingPercent = [...chargeUserAmountRate];
      }));
    },
    // 近一个月充电电量与充电次数趋势  碳减排趋势
    fetchMonthAnalyseData(stubGroupId) {
      getMonthAnalyseData({ stubGroupId }).then((res) => {
        const xData = [];
        const Power = [];
        const ChargeNumArr = [];
        const chargeUserAmountArr = [];
        const carbonReductionRateArr = [];
        if (res.code === '200' && res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            const {
              date, power, chargeUserAmount, carbonReductionRate, chargeNum,
            } = res.data[i];
            xData.push(getTime(date * 1000, 'month-date'));
            Power.push(power);
            ChargeNumArr.push(chargeNum);
            chargeUserAmountArr.push(Number(chargeUserAmount));
            // recentMonthUserData.push(chargeUserAmount);
            carbonReductionRateArr.push(toDecimal(carbonReductionRate));
          }

          this.recentMonthUserData.userNumber = [...chargeUserAmountArr];

          this.carbonEmissionsData.index = xData; // 月份
          this.carbonEmissionsData.chargingCapacity = [...chargeUserAmountArr]; // 充电用户
          this.carbonEmissionsData.reduceCarbon = [...carbonReductionRateArr]; // 碳减排
          this.graphGradientData.index = xData;
          this.graphGradientData.chargingCapacity = Power;
          this.graphGradientData.chargeTimes = [...ChargeNumArr];
        }
      });
    },
    // 获取充电现状数据
    fecthChargeStatus(stubGroupId) {
      getChargeStatus({ stubGroupId }).then((res) => {
        // this.statisticsData.adcCharging = res.data.adcCharging;
        this.chargingConditionData[0].value = res.data.adcCharging;
        this.chargingConditionData[0].baifenbi = res.data.adcChargingRatio * 100;
        this.chargingConditionData[1].value = res.data.adcFree;
        this.chargingConditionData[1].baifenbi = res.data.adcFreeRatio * 100;
        this.chargingConditionData[2].value = res.data.adcOffLine;
        this.chargingConditionData[2].baifenbi = res.data.adcOffLineRatio * 100;
        this.chargingConditionData[3].value = res.data.adcFault;
        this.chargingConditionData[3].baifenbi = res.data.adcFaultRatio * 100;
        this.chargingConditionData[4].value = res.data.rests;
        this.chargingConditionData[4].baifenbi = res.data.restsRatio * 100;
      });
    },
    // 请求充电过程数据
    fetchChargingProcess(id) {
      getChargingProcess({
        stubGroupId: id,
      }).then((res) => {
        if (res.code === '200') {
          this.processLsit = res.data;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.station-charge-modal {
  .station-charge-content {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 0 50px;
    padding-top: 52px;
    display: grid;
    grid-template-columns: 470px auto 470px;
    grid-template-rows: 100%;
    .center {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }

}
</style>
